// extracted by mini-css-extract-plugin
module.exports = {"trailResultCard":"styles-module__trailResultCard___1LJgj","imageCarousel":"styles-module__imageCarousel___23Ofi"};